/**
  * course模块接口列表
  */

import base from './base'; // 导入接口域名列表
import axios from '@/axios'; // 导入axios实例
import qs from 'qs';
//let path = base.default+'/ArtAppWeb/rest';
// let path = '/test/ArtAppWebTest/rest';
//let path  = '/fei/ArtAppWeb/rest';
//let path = '/jing/ArtAppWeb/rest';
//let path = '/ArtAppWeb6_9_0/rest';
let path = base.default;

const obj = {

    //查询Banner列表
    websitContentGetBannerList(params) {
        return axios.get(`${path}/websitContent/getBannerList`, {params:params});
    },
    //查询Banner详情
    websitContentGetBannerInfo(params) {
        return axios.get(`${path}/websitContent/getBannerInfo`, {params:params});
    },
    //查询新闻·活动列表
    websitContentGetNewsActivityList(params) {
        return axios.get(`${path}/websitContent/getNewsActivityList`, {params:params});
    },
    //查询新闻·活动详情
    websitContentGetNewsActivityInfo(params) {
        return axios.get(`${path}/websitContent/getNewsActivityInfo`, {params:params});
    },
    //查询合作单位列表
    websitContentGetCooperationUnitList(params) {
        return axios.get(`${path}/websitContent/getCooperationUnitList`, {params:params});
    },
    //查询合作单位详情
    websitContentGetCooperationUnitInfo(params) {
        return axios.get(`${path}/websitContent/getCooperationUnitInfo`, {params:params});
    },
    //查询课程预告列表
    websitContentGetCourseNoticeList(params) {
        return axios.get(`${path}/websitContent/getCourseNoticeList`, {params:params});
    },
    //查询课程预告详情
    websitContentGetCourseNoticeInfo(params) {
        return axios.get(`${path}/websitContent/getCourseNoticeInfo`, {params:params});
    },
    //查询教师详情
    getTeacherInfoByUserId(params) {
        return axios.get(`${path}/websitContent/getTeacherInfoByUserId`, {params:params});
    },
    //社区大讲堂点击单课查询同系列社区大讲堂课程
    communityCourseSelectSameSeriesCommunityCourse(params) {
        return axios.post(`${path}/communityCourse/selectSameSeriesCommunityCourse`, qs.stringify(params));
    },
    //专家点击查询专家对应社区大讲堂课程
    communityCourseSelectCommunityCourseByUserId(params) {
        return axios.post(`${path}/communityCourse/selectCommunityCourseByUserId`, qs.stringify(params));
    },

    //8个大讲堂课程列表
    communityCourseSelectTop10Courses(params) {
        return axios.post(`${path}/communityCourse/selectTop10Courses`, qs.stringify(params));
    },

    /*课程征集目录*/
    //查询课程征集目录列表-对应的专业
    websitContentSelectCourseCollectionCode(params) {
        return axios.get(`${path}/websitContent/selectCourseCollectionCode`, {params:params});
    },
    //查询课程征集目录列表
    websitContentSelectCourseCollectionCatalogueList(params) {
        return axios.get(`${path}/websitContent/selectCourseCollectionCatalogueList`, {params:params});
    },
    //根据id获取课程征集信息详情
    websitContentSelectCourseCollectionCatalogueById(params) {
        return axios.get(`${path}/websitContent/selectCourseCollectionCatalogueById`, {params:params});
    },
    //添加课程征集活动
    websitContentAddCourseCollection(params) {
        return axios.post(`${path}/websitContent/addCourseCollection`, qs.stringify(params));
    },

    //查询专家列表
    websitContentSelectProfessorList(params) {
        return axios.get(`${path}/websitContent/selectProfessorList`, {params:params});
    },
    //查询工作室老师列表
    websitContentSelectTeacherList(params) {
        return axios.get(`${path}/websitContent/selectTeacherList`, {params:params});
    },
    //查询老师个人风采
    websitContentSelectTeacherShineListByTeacherId(params) {
        return axios.get(`${path}/websitContent/selectTeacherShineListByTeacherId`, {params:params});
    },
    //查询老师证书列表
    getUserCertificateListByUserId(params){
        return axios.get(`${path}/websitContent/getUserCertificateListByUserId`, {params:params});
    }, 

    //查询老师社区大讲堂课程列表
    websitContentSelectCommunityCourseListByUserId(params) {
        return axios.get(`${path}/websitContent/selectCommunityCourseListByUserId`, {params:params});
    },  
    //查询老师参与的测评列表
    websitContentSelectEvaluationListByTeacherId(params) {
        return axios.get(`${path}/websitContent/selectEvaluationListByTeacherId`, {params:params});
    },  
    //根据测评id统计测评的成绩等级和通过率
    websitContentCountEvaluationOrderLevel(params) {
        return axios.get(`${path}/websitContent/countEvaluationOrderLevel`, {params:params});
    }, 
    
    //查询工作室详情
    communityCourseSelectStudioInfoByStudioId(params) {
        return axios.post(`${path}/communityCourse/selectStudioInfoByStudioId`, qs.stringify(params));
    },
    //工作室点击查询对应的工作室老师
    communityCourseSelectStudioMemberByStudioId(params) {
        return axios.post(`${path}/communityCourse/selectStudioMemberByStudioId`, qs.stringify(params));
    },
    //工作室点击查询对应社区大讲堂课程
    communityCourseSelectCommunityCourseByStudioId(params) {
        return axios.post(`${path}/communityCourse/selectCommunityCourseByStudioId`, qs.stringify(params));
    },
    
    //查询机构对应的大讲堂课程
    communityCourseSelectCommunityCourseByInstitutionId(params) {
        return axios.post(`${path}/communityCourse/selectCommunityCourseByInstitutionId`, qs.stringify(params));
    },

    //查询成绩(废弃的页面，待删除)
    studioEvaluationSelectUserGradesByCertificateNo(params) {
        return axios.post(`${path}/studioEvaluation/selectUserGradesByCertificateNo`, qs.stringify(params));
    },

    //查询已审核通过的课程征集明细
    websitContentSelectCourseCollectionAuditPass(params) {
        return axios.get(`${path}/websitContent/selectCourseCollectionAuditPass`, {params:params});
    }, 

    /*证书、报告查询*/
    //发送验证码（不返回code）(废弃)
    sendSmsCodeByType(params){
        return axios.post(`${path}/user/sendSmsCodeByType`,qs.stringify(params));
    },
    //发送验证码
    sendCodeByType(params){
        return axios.post(`${path}/user/sendCodeByType`,qs.stringify(params));
    },
    //验验证码是否正确（废弃）
    checkSmsCodeByType(params){
        return axios.post(`${path}/user/checkSmsCodeByType`,qs.stringify(params));
    },
    //根据token查询用户测评成绩报告
    selectEvaluationResult(params){
        return axios.post(`${path}/studioEvaluation/selectEvaluationResult`,qs.stringify(params));
    },
    //根据报名id获取报名成绩(报告详情)
    getEvaluationResultScore(params){
        return axios.post(`${path}/studioEvaluation/getEvaluationResultScore`,qs.stringify(params));
    },
    //根据userId查询个人证书列表(废弃)
    selectCertificateListByUserId(params){
        return axios.post(`${path}/studioEvaluation/selectCertificateListByUserId`,qs.stringify(params));
    },
    //通过账号、验证码查询证书列表
    selectCertificateListByAccount(params){
        return axios.post(`${path}/studioEvaluation/selectCertificateListByAccount`,qs.stringify(params));
    },
    //查询共享行动单位列表
    artmapOfStudioEvaluationSelectStudioAllianceList(params){
        return axios.post(`${path}/artmapOfStudioEvaluation/selectStudioAllianceList`,qs.stringify(params));
    },

    //查询测评报告列表
    assessmentReportGetReportList(params){
        return axios.post(`${path}/assessment/report/getReportList`,qs.stringify(params));
    },
    //查询报告详情
    assessmentReportGetReportDesc(params){
        return axios.post(`${path}/assessment/report/getReportDesc`,qs.stringify(params));
    },

}

export default obj;
